<div class="appointment-choice">
  <div class="appointment-choice__content">
    <app-header />

    <div class="appointment-choice__main">
      <section class="appointment-choice__hero" aria-labelledby="appointment-choice-title">
        <h1 id="appointment-choice-title" class="appointment-choice__title">
          Avez-vous un rendez-vous ?
        </h1>
      </section>

      <section class="appointment-choice__cards" aria-label="Choix de rendez-vous">
        <div class="appointment-choice__cards-row">
          @for (option of appointmentOptions; track option.variant) {
            <div class="appointment-choice__card">
              <app-identification-card
                [variant]="option.variant"
                [title]="option.title"
                subtitle=""
                [illustrationSrc]="option.illustrationSrc"
                [illustrationAlt]="option.illustrationAlt"
                (pressed)="onOptionSelected(option.variant)"
              />
            </div>
          }
        </div>
      </section>
    </div>

    <app-footer>
      <app-footer-nav [showScrollButton]="false" backRoute="/visitor-identification" />
    </app-footer>
  </div>
</div>